import { STOModel } from "src/models/base/sto-model";
// import { ListSortDirection, Sort } from "../../models/api/sort";
import { AnomalyTrackingDTO } from "../../models/tna/tna-anomalies/anomaly-tracking-dto";
import { BaseApiService } from "../base/base-api.service";

export class AnomalyTrackingByEmployee extends BaseApiService<AnomalyTrackingDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Anomaly",
      loadItemsPath: "/GetAnomalyTrackingByEmployee",
    });

    // this.defaultSort = [
    //   {
    //     name: "date",
    //     direction: ListSortDirection.Descending,
    //   } as Sort,
    // ];
  }
}
